$(document).ready(function () {
  $(".fun_slider").slick({
    slidesToShow: 4,
    autoplay: true,
    arrows: false,
    dots: false,
    loop: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          variableWidth: true,
          slidesToShow: 1,
        },
      },
    ],
  });
});
window.addEventListener("load", function () {
  var videos = document.getElementsByClassName("myVideo");
  for (var i = 0; i < videos.length; i++) {
    videos[i].setAttribute("preload", "metadata");
    videos[i].load();
  }
});
